<template>
  <div class="open-app-bar">
    <div>
      <div class="c-home-icon" v-if="showHome" @click="jumpToHome">
        <div class="icon"></div>
        <div class="line"></div>
      </div>
      <img class="img" src="@/assets/images/logo.png" alt />
      <span class="title">CEO的新商业学堂</span>
    </div>
    <template v-if="origin=='miniprogram'">
      <!-- <span class="bottom" @click="jumpToGuide">立即打开</span> -->
    </template>
    <template v-else>
      <span class="bottom" v-if="isMobileWx">
        <!-- {{origin}} -->
        <open-app-wx
          :style="{width: 160 * ratio + 'px',
          lineHeight: 54 * ratio + 'px',
          textAlign: 'center',
          color: '#fff',
          fontSize: 28 * ratio + 'px',}"
        ></open-app-wx>
      </span>
      <span v-else class="bottom" @click="jumpToApp">立即打开</span>
    </template>
  </div>
</template>

<script>
import OpenAppWx from './open-app-wx.vue'
export default {
  props: {
    openAppInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    showHome: {
      default: true,
      type: Boolean,
    },
  },
  components: { OpenAppWx },
  methods: {
    jumpToHome() {
      this.$router.push({
        name: 'home',
        query: { adminId: this.$route.query.adminId },
      })
    },
    jumpToApp() {
      this.openApp({
        jumpType: this.openAppInfo.jumpType,
        resourceId: this.openAppInfo.resourceId,
        goodsType: this.openAppInfo.goodsType,
        goodsId: this.openAppInfo.goodsId,
      })
    },
    jumpToGuide() {
      this.$router.push({
        name: 'download',
      })
    },
  },
}
</script>

<style lang="less">
.c-home-icon {
  display: flex;
  flex: 94px 0 0;
  justify-content: space-between;
  margin-right: 48px;
  .icon {
    display: block;
    width: 56px;
    height: 56px;
    background: url('~@/assets/images/home/home.png') no-repeat 0 0;
    background-size: 100% 100%;
  }
  .line {
    width: 4px;
    height: 40px;
    background: #dcdcdc;
  }
}
.open-app-bar {
  width: 750px;
  height: 90px;
  background: #f4f6f7;
  padding: 0 32px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
    .img {
      width: 46px;
      height: 46px;
      background: #ffffff;
      border-radius: 8px;
      margin-right: 20px;
      border: 1px solid rgba(255, 255, 255, 0.56);
    }

    .title {
      flex: 300px 0 0;
      text-align: left;
      font-size: 32px;
      color: #333333;
    }
  }

  .bottom {
    width: 160px;
    height: 54px;
    font-size: 28px;
    line-height: 54px;
    text-align: center;
    color: #ffffff;
    background: linear-gradient(90deg, #ff8e00 0%, #ff5500 100%);
    border-radius: 28px;
    position: relative;
  }
}
</style>